// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"loading_wrapper__Gvp__","hide":"loading_hide__hM2ym"};